<template>
  <div class="row form-group form-group-default" >
    <div class="col-12 m-b-10 p-2">
      <label> {{ $t('models.user.services') }} </label>
    </div>

    <div v-for="hubServices in groupedServices" :class="cardClasses">
      <div class="hub-form b-a b-grey">
        <div class="hub-form__header text-center b-b b-grey" >
          <a class="hub-toggler block p-2"
             :class="collapseHubs ? 'collapsed' : ''"
             role="button"
             data-toggle="collapse"
             :href="collapseHREFFor(hubServices)"
             aria-expanded="false"
             aria-controls="collapseExample">
            <div class="row">
              <div class="col-10 col-xs-10 col-sm-11 hub-form__header__hub-name">
                {{ hubServices.label }}
              </div>
              <div class="col-2 col-xs-2 col-sm-1 text-right">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </div>
            </div>
          </a>
        </div>

        <div class="hub-form__body collapse p-2"
             :class= "{ in: !collapseHubs, show: !collapseHubs }"
             :id="collapseIDFor(hubServices)">

          <div class="col-12">
            <div class="select-all">
              <a v-if="allServicesForHubSelected(hubServices.hub_id)" href="#" @click="onDeselectAllHubs(hubServices.hub_id)">
                Tout décocher
              </a>
              <a v-else href="#" @click="onSelectAllHubs(hubServices.hub_id)">
                Tout cocher
              </a>
            </div>
          </div>

          <div v-for="service in hubServices.services"
               :key="service.id"
               class="checkbox check-success">
            <input type="checkbox"
                   :id="`service_${service.id}`"
                   :value="`${service.id}`"
                   v-model="internalSelectedServices"
                   @change="onChange"
                   :name="fieldName"
                   :disabled="disabledConditions"
                   v-validate="servicesValidationRules">
            <label :for="`service_${service.id}`">
              {{ service.name }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 m-b-10 p-2">
      <label v-show="errors.has(fieldName)"
             id="services-error"
             class="error"
             :for="fieldName">
        {{ errors.first(fieldName) }}
      </label>
    </div>
  </div>
</template>

<script>
import UniversalMultiselect from '@/components/form/UniversalMultiselect'
import _ from 'lodash'

export default {
  name: 'ServicesFieldGroupByHub',
  inject: ['$validator'],
  props: {
    affiliatedService: Object,
    availableServices: Array,
    selectedServices: Array,
    availableHubs: Array,
    disabledConditions: Boolean,
    isManager: Boolean,
    isInternal: Boolean,
    collapseHubs: { type: Boolean, default: false },
    fieldNameAddition: { type: [String, Number], default: null },
    small: { type: Boolean, default: false },
  },
  data() {
    return {
      internalSelectedServices: this.selectedServices.map((service) => `${service.id}`),
    }
  },
  watch: {
    selectedServices: function() {
      this.internalSelectedServices = this.selectedServices.map((service) => `${service.id}`)
    }
  },
  methods: {
    onChange(values) {
      var toEmit = this.availableServices.filter((service) => this.internalSelectedServices.includes(`${service.id}`))
      this.$emit('change', toEmit)
    },
    onSelectAllHubs(value) {
      if(this.disabledConditions) {
        return
      }

      var servicesToSelect = this.availableServices.filter((service) => {
        return (`${service.hub_id}` == value ||
                this.internalSelectedServices.includes(`${service.id}`))
      })
      this.$emit('change', servicesToSelect)
    },
    onDeselectAllHubs(value) {
      if(this.disabledConditions) {
        return
      }

      var servicesToDeselect = this.availableServices.filter((service) => {
        return (`${service.hub_id}` != value &&
                this.internalSelectedServices.includes(`${service.id}`))
      })
      this.$emit('change', servicesToDeselect)
    },
    servicesForHub(hub_id) {
      return this.availableServices.filter((service) => `${service.hub_id}` == hub_id)
    },
    allServicesForHubSelected(hub_id) {
      return this.servicesForHub(hub_id).every((service) => this.internalSelectedServices.includes(`${service.id}`))
    },
    collapseIDFor(hubServices) {
      return "hub-id-" + hubServices.hub_id
    },
    collapseHREFFor(hubServices) {
      return "#" + this.collapseIDFor(hubServices)
    }
  },
  computed: {
    cardClasses() {
      if(this.small) {
        return 'col-12 col-md-6 hub-card'
      }
      return "col-md-6 col-lg-4 hub-card"
    },
    servicesValidationRules(){
      return (this.isInternal && !this.isManager) ? `required|affiliated:${this.isAffiliatedServiceInServicesList}` : 'required'
    },
    isAffiliatedServiceInServicesList(){
      if (this.selectedServices && this.affiliatedService) {
        return this.selectedServices.map(service => service.id).includes(this.affiliatedService.id)
      }
      return false
    },
    fieldName() {
      return this.fieldNameAddition ? `services_${this.fieldNameAddition}` : 'services';
    },
    groupedServices() {
      var groupedServices = []
      var groupedServicesHash = _.groupBy(this.availableServices, 'hub_id')
      Object.keys(groupedServicesHash).forEach((hub_id) => {
        groupedServices.push({
          label: this.availableHubs.find((hub) => hub.id == hub_id).name,
          hub_id: hub_id,
          services: groupedServicesHash[hub_id]
        })
      })
      return groupedServices
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/pages/_var.scss';
.select-all a{
  color: $color-pink;
  font-size: 12px;
}
.form-group-default.focused {
  background: none!important;
  label.fade, label {
    opacity: 1;
  }
}
.form-group-default label.fade {
  opacity: 1;
}
.checkbox {
  margin-bottom: 0;
  margin-top: 0;
  line-height: 0.5;
}
.hub-form {
  box-shadow: 0 0 14px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  &__header {
    font-family: 'Montserrat';
    font-size: 10.5px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    font-weight: 500;
    &__hub-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .hub-toggler {
      .fa.fa-chevron-down {
        transition: all 250ms;
      }
    }
    .hub-toggler.collapsed {
      .fa.fa-chevron-down {
        transform: rotate(-90deg);
      }
    }
  }

  &__body.collapse.in,
  &__body.collapse.show{
    height: 200px;
  }
  &__body {
    overflow-y: scroll;
    label {
      letter-spacing: initial;
      text-transform: initial;
      font-weight: initial;
      font-size: 14px;
      font-family: "Segoe UI", Arial, sans-serif;
    }
  }
}
.ie .modal-content {
  max-width: 1000px;
}
.ie .hub-card {
  width: 250px;
  flex: none;
}
.row.form-group.form-group-default {
  margin-left: 0;
  margin-right: 0
}
</style>



// WEBPACK FOOTER //
// src/components/users/form/ServicesFieldGroupByHub.vue